import React from 'react';

import { motion } from 'framer-motion';

export interface FilterPillProps {
    label: string;
    count: number;
    isSelected: boolean;
    onSelect: (label: string) => void;
    testId?: string;
    dataMaterialType?: string;
}

export function FilterPill({ label, count, isSelected, onSelect, testId, dataMaterialType }: FilterPillProps) {
    return (
        <motion.button
            type="button"
            data-testid={testId}
            data-material-type={dataMaterialType}
            aria-pressed={isSelected}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onSelect(label)}
            className={`flex items-center space-x-1 px-2 py-1 rounded-md border text-xs font-medium transition-all duration-300 ${
                isSelected
                    ? 'border-blue-500 bg-blue-50 text-blue-700'
                    : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50'
            }`}
        >
            <span>{label}</span>
            <span
                className={`px-1 py-0.5 text-xs rounded-full ${
                    isSelected ? 'bg-blue-200 text-blue-700' : 'bg-slate-200 text-slate-600'
                }`}
            >
                {count}
            </span>
        </motion.button>
    );
}
